module.exports = __webpack_public_path__ + "img/wmbn.3be94993.png";